import { FormHelperText } from '@material-ui/core';
import styled from 'styled-components';

export const UiRadioGroup = styled.div`
	display: flex;
  align-items: center;
`;

export const UiFormLabel = styled.div`
	display: flex;
	align-items: center;
	min-width: 150px;
	font-size: 1rem;
	color: rgba(0, 0, 0, 0.54);
	line-height: 1.1875em;
`;

export const UiFormHelperText = styled(FormHelperText)`
	color: #f44336;
`;
